/**
 * HoverLink
 *
 * Adds a `.hover` class to the `.hover-link` element contained within
 * a `[data-hover-link]` element when the user hovers over it.
 *
 * Example:
 *
 * <div data-hover-link>
 *     <h2>Example content</h2>
 *     <a class="hover-link" href="#">Read more</a>
 * </div>
 *
 * When hovering over `[data-hover-link]`, the link becomes:
 *
 * <a class="hover-link hover" href="#">Read more</a>
 */

class HoverLink {
    constructor() {
        this.items = document.querySelectorAll('[data-hover-link]');

        this.init();
    }

    init() {
        this.items.forEach((item) => {
            const link = item.querySelector('.hover-link');

            // Ignore items without a hover link
            if (!link) return;

            item.addEventListener('mouseenter', () => {
                link.classList.add('hover');
            });

            item.addEventListener('mouseleave', () => {
                link.classList.remove('hover');
            });
        });
    }
}

export default new HoverLink();
